import axios from "axios";
import { CONTRACTS_PER_CHUNK, chunkLoadProgress, loadInChunks, startChunkLoad } from "../chunkedLoader";
import i18next from "i18next";
import { inlineRefusalOf } from "../../utils/uniquenessRefusal";
import { toast } from "react-toastify";
import { PDA_PREFIX } from "../../global/constants";

import {
  GET_ERRORS,
  GET_PORTFOLIO_USAGE_REQUEST,
  GET_PORTFOLIO_USAGE_SUCCESS,
  GET_PORTFOLIO_USAGE_ERROR,
  GET_SCENARIO_USAGE_REQUEST,
  GET_SCENARIO_USAGE_SUCCESS,
  GET_SCENARIO_USAGE_ERROR,
  DELETE_RESOURCE_REQUEST,
  DELETE_RESOURCE_SUCCESS,
  DELETE_RESOURCE_ERROR,
  CREATE_RESOURCE_REQUEST,
  CREATE_RESOURCE_SUCCESS,
  CREATE_RESOURCE_ERROR,
  GET_RESOURCES_BY_SCENARIO_ID_REQUEST,
  GET_RESOURCES_BY_SCENARIO_ID_SUCCESS,
  GET_RESOURCES_BY_SCENARIO_ID_ERROR,
  GET_COLLABS_REQUEST,
  GET_COLLABS_SUCCESS,
  GET_COLLABS_ERROR,
  UPDATE_RESOURCE_REQUEST,
  UPDATE_RESOURCE_SUCCESS,
  UPDATE_RESOURCE_ERROR,
  CLEAR_RESOURCES,
  CLEAR_BACKEND_ERROR_MESSAGE,
  CREATE_MANAGER_REQUEST,
  CREATE_MANAGER_SUCCESS,
  CREATE_MANAGER_ERROR,
  DELETE_MANAGER,
  CREATE_COLLABS_REQUEST,
  CREATE_COLLABS_SUCCESS,
  CREATE_COLLABS_ERROR,
  DELETE_COLLAB,
  RESET_WEEKLY_CAPACITY,
  ERASE_CAPACITY,
  UPDATE_SIMULATION_USAGE,
  GET_MAPPED_RESOURCES_REQUEST,
  GET_MAPPED_RESOURCES_SUCCESS,
  GET_MAPPED_RESOURCES_ERROR,
  GET_SPECIFIC_NON_LABOR_RESOURCES_REQUEST,
  GET_SPECIFIC_NON_LABOR_RESOURCES_SUCCESS,
  GET_SPECIFIC_NON_LABOR_RESOURCES_ERROR,
  GET_PORTFOLIO_COLLABS_AND_SPECIFIC_RESOURCES_REQUEST,
  GET_PORTFOLIO_COLLABS_AND_SPECIFIC_RESOURCES_SUCCESS,
  GET_PORTFOLIO_COLLABS_AND_SPECIFIC_RESOURCES_ERROR,
  GET_COLLABS_AND_SPECIFIC_RESOURCES_OF_USER_REQUEST,
  GET_COLLABS_AND_SPECIFIC_RESOURCES_OF_USER_SUCCESS,
  GET_COLLABS_AND_SPECIFIC_RESOURCES_OF_USER_ERROR,
  GET_TEAMS_REQUEST,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_ERROR,
  GET_MY_TEAMS_REQUEST,
  GET_MY_TEAMS_SUCCESS,
  GET_MY_TEAMS_ERROR,
  GENERATE_TEAMS_WORKLOAD,
  RESET_USAGES,
  SIMULATION_PROCESS,
  SIMULATION_SUCCESS,
  SIMULATION_ERROR,
  GET_DIMENSION_RESOURCES_REQUEST,
  GET_DIMENSION_RESOURCES_ERROR,
  GET_DIMENSION_RESOURCES_SUCCESS,
  FETCH_SHIFTS_REQUEST,
  FETCH_ALL_SHIFTS_SUCCESS,
  FETCH_ALL_SHIFTS_ERROR,
  MUTATE_SHIFTS_WITHOUT_RERENDER,
  DELETE_SHIFT_SUCCESS,
  DELETE_SHIFT_ERROR,
  UPDATE_SHIFTS_REQUEST,
  UPDATE_SHIFTS_SUCCESS,
  UPDATE_SHIFTS_ERROR,
  CREATE_SHIFT_REQUEST,
  CREATE_SHIFT_SUCCESS,
  CREATE_SHIFT_ERROR,
  FETCH_ALL_BUDGET_ENVELOPES_REQUEST,
  FETCH_ALL_BUDGET_ENVELOPES_SUCCESS,
  FETCH_ALL_BUDGET_ENVELOPES_ERROR,
  UPDATE_BUDGET_ENVELOPE_ERROR,
  UPDATE_BUDGET_ENVELOPE_SUCCESS,
  UPDATE_BUDGET_ENVELOPE_REQUEST,
  GET_AUTHORIZATIONS_AND_CAPABILITIES,
  UPDATE_AUTHORIZATIONS_AND_CAPABILITIES_ASSIGNED,
} from "../types";
import { logout } from "../security-services/SecurityActions";
import logoutforSpecificErrorCodes from "../../securityUtils/LogoutUtils";
import {
  addItemPending,
  removeItemPending,
} from "../utils-services/utilsActions";

const createResourceRequest = () => ({
  type: CREATE_RESOURCE_REQUEST,
});
const createResourceSuccess = (resource) => ({
  type: CREATE_RESOURCE_SUCCESS,
  payload: resource,
});
const createResourceError = (err) => ({
  type: CREATE_RESOURCE_ERROR,
  payload: err,
});

const createManagerRequest = () => ({
  type: CREATE_MANAGER_REQUEST,
});
const createManagerSuccess = (managers) => ({
  type: CREATE_MANAGER_SUCCESS,
  payload: managers,
});
const createManagerError = (err) => ({
  type: CREATE_MANAGER_ERROR,
  payload: err,
});

const createCollabsRequest = () => ({
  type: CREATE_COLLABS_REQUEST,
});

const createCollabsSuccess = (data) => ({
  type: CREATE_COLLABS_SUCCESS,
  payload: data,
});

const createCollabsError = (err) => ({
  type: CREATE_COLLABS_ERROR,
  payload: err,
});

const updateResourceRequest = () => ({
  type: UPDATE_RESOURCE_REQUEST,
});
const updateResourceSuccess = (resource) => ({
  type: UPDATE_RESOURCE_SUCCESS,
  payload: resource,
});
const updateResourceError = (err) => ({
  type: UPDATE_RESOURCE_ERROR,
  payload: err,
});

const deleteResourceRequest = () => ({
  type: DELETE_RESOURCE_REQUEST,
});

const deleteResourceSuccess = (resource) => ({
  type: DELETE_RESOURCE_SUCCESS,
  payload: resource,
});

const deleteResourceError = (err) => ({
  type: DELETE_RESOURCE_ERROR,
  payload: err,
});

const getMappedResourcesRequest = () => ({
  type: GET_MAPPED_RESOURCES_REQUEST,
});
const getMappedResourcesSuccess = (resources) => ({
  type: GET_MAPPED_RESOURCES_SUCCESS,
  payload: resources,
});
const getMappedResourcesError = (err) => ({
  type: GET_MAPPED_RESOURCES_ERROR,
  payload: err,
});

const getResourcesByScenarioIdRequest = () => ({
  type: GET_RESOURCES_BY_SCENARIO_ID_REQUEST,
});
const getResourcesByScenarioIdSuccess = (resources) => ({
  type: GET_RESOURCES_BY_SCENARIO_ID_SUCCESS,
  payload: resources,
});
const getResourcesByScenarioIdError = (err) => ({
  type: GET_RESOURCES_BY_SCENARIO_ID_ERROR,
  payload: err,
});

const getPortfolioUsageRequest = () => ({
  type: GET_PORTFOLIO_USAGE_REQUEST,
});
const getPortfolioUsageSuccess = (usages) => ({
  type: GET_PORTFOLIO_USAGE_SUCCESS,
  payload: usages,
});
const getPortfolioUsageError = (err) => ({
  type: GET_PORTFOLIO_USAGE_ERROR,
  payload: err,
});

const getScenarioUsageRequest = () => ({
  type: GET_SCENARIO_USAGE_REQUEST,
});

const getScenarioUsageSuccess = (tenant) => ({
  type: GET_SCENARIO_USAGE_SUCCESS,
  payload: tenant,
});

const getDimensionResourcesRequest = () => ({
  type: GET_DIMENSION_RESOURCES_REQUEST,
});

const getDimensionResourcesSuccess = (data) => {
  return {
    type: GET_DIMENSION_RESOURCES_SUCCESS,
    payload: data,
  };
};

const getDimensionResourcesError = (err) => ({
  type: GET_DIMENSION_RESOURCES_ERROR,
  payload: err,
});

const getScenarioUsageError = (err) => ({
  type: GET_SCENARIO_USAGE_ERROR,
  payload: err,
});

const getCollabsRequest = () => ({
  type: GET_COLLABS_REQUEST,
});
const getCollabsSuccess = (collabs) => ({
  type: GET_COLLABS_SUCCESS,
  payload: collabs,
});
const getCollabsError = (err) => ({
  type: GET_COLLABS_ERROR,
  payload: err,
});

const getPortfolioCollabsAndSpecificResourcesRequest = () => ({
  type: GET_PORTFOLIO_COLLABS_AND_SPECIFIC_RESOURCES_REQUEST,
});
const getPortfolioCollabsAndSpecificResourcesSuccess = (data) => ({
  type: GET_PORTFOLIO_COLLABS_AND_SPECIFIC_RESOURCES_SUCCESS,
  payload: data,
});
const getPortfolioCollabsAndSpecificResourcesError = (err) => ({
  type: GET_PORTFOLIO_COLLABS_AND_SPECIFIC_RESOURCES_ERROR,
  payload: err,
});

const getCollabsAndSpecificResourcesOfUserRequest = () => ({
  type: GET_COLLABS_AND_SPECIFIC_RESOURCES_OF_USER_REQUEST,
});
const getCollabsAndSpecificResourcesOfUserSuccess = (data) => ({
  type: GET_COLLABS_AND_SPECIFIC_RESOURCES_OF_USER_SUCCESS,
  payload: data,
});
const getCollabsAndSpecificResourcesOfUserError = (err) => ({
  type: GET_COLLABS_AND_SPECIFIC_RESOURCES_OF_USER_ERROR,
  payload: err,
});

const getTeamsRequest = () => ({
  type: GET_TEAMS_REQUEST,
});

const getTeamsSuccess = (data) => ({
  type: GET_TEAMS_SUCCESS,
  payload: data,
});

const getTeamsError = (err) => ({
  type: GET_TEAMS_ERROR,
  payload: err,
});

const getMyTeamsRequest = () => ({
  type: GET_MY_TEAMS_REQUEST,
});

const getMyTeamsSuccess = (data) => ({
  type: GET_MY_TEAMS_SUCCESS,
  payload: data,
});

const getMyTeamsError = (err) => ({
  type: GET_MY_TEAMS_ERROR,
  payload: err,
});

const getSpecificNonLaborResourcesRequest = () => ({
  type: GET_SPECIFIC_NON_LABOR_RESOURCES_REQUEST,
});
const getSpecificNonLaborResourcesSuccess = (resources) => ({
  type: GET_SPECIFIC_NON_LABOR_RESOURCES_SUCCESS,
  payload: resources,
});
const getSpecificNonLaborResourcesError = (err) => ({
  type: GET_SPECIFIC_NON_LABOR_RESOURCES_ERROR,
  payload: err,
});

export const resetUsages = () => ({ type: RESET_USAGES });

export const updateSimulationUsage = (usages) => ({
  type: UPDATE_SIMULATION_USAGE,
  payload: usages,
});

export const simulationProcess = () => ({ type: SIMULATION_PROCESS });
export const simulationSuccess = (payload) => ({
  type: SIMULATION_SUCCESS,
  payload,
});
export const simulationError = (err) => ({
  type: SIMULATION_ERROR,
  payload: err,
});

const createShiftRequest = () => ({
  type: CREATE_SHIFT_REQUEST,
});

const createShiftSuccess = (shift) => ({
  type: CREATE_SHIFT_SUCCESS,
  payload: shift,
});

const createShiftError = (err) => ({
  type: CREATE_SHIFT_ERROR,
  payload: err,
});

const fetchShiftsRequest = () => ({
  type: FETCH_SHIFTS_REQUEST,
});

const fetchAllShiftsSuccess = (data) => ({
  type: FETCH_ALL_SHIFTS_SUCCESS,
  payload: data,
});

const fetchAllShiftsError = (err) => ({
  type: FETCH_ALL_SHIFTS_ERROR,
  payload: err,
});

const updateShiftsRequest = () => ({
  type: UPDATE_SHIFTS_REQUEST,
});

const updateShiftsSuccess = (data) => ({
  type: UPDATE_SHIFTS_SUCCESS,
  payload: data,
});

const updateShiftsError = (err) => ({
  type: UPDATE_SHIFTS_ERROR,
  payload: err,
});

const deleteShiftSuccess = (data) => ({
  type: DELETE_SHIFT_SUCCESS,
  payload: data,
});

const deleteShiftError = (err) => ({
  type: DELETE_SHIFT_ERROR,
  payload: err,
});

const fetchAllBudgetEnvelopesRequest = () => ({
  type: FETCH_ALL_BUDGET_ENVELOPES_REQUEST,
});

const fetchAllBudgetEnvelopesSuccess = (data) => ({
  type: FETCH_ALL_BUDGET_ENVELOPES_SUCCESS,
  payload: data,
});

const fetchAllBudgetEnvelopesError = (err) => ({
  type: FETCH_ALL_BUDGET_ENVELOPES_ERROR,
  payload: err,
});

export const updateBudgetEnvelopeRequest = () => ({
  type: UPDATE_BUDGET_ENVELOPE_REQUEST,
});

export const updateBudgetEnvelopeSuccess = (budgetEnvelope) => ({
  type: UPDATE_BUDGET_ENVELOPE_SUCCESS,
  payload: budgetEnvelope,
});

export const updateBudgetEnvelopeError = (error) => ({
  type: UPDATE_BUDGET_ENVELOPE_ERROR,
  payload: error,
});

/**
 * Readable text for a failed resource call, whatever shape the failure has:
 * a validation map ({ name: "..." }), a plain-string body, or no response at
 * all. Never returns an object — toast.error would render "[object Object]".
 */
const resourceErrorText = (err, fallback) => {
  const refusal = inlineRefusalOf(i18next.t, err);
  if (refusal) return refusal.name || refusal.code;
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  const field = data?.name || data?.message || data?.error;
  if (typeof field === "string" && field.trim()) return field;
  return err?.message || fallback;
};

export const addResource = (
  resource,
  isLabor = true,
  hasNoShifts = false
) => async (dispatch) => {
  dispatch(createResourceRequest());
  try {
    const res = await axios.post(`${PDA_PREFIX}/resource/add`, resource);
    if (hasNoShifts) dispatch(fetchAllShiftsSuccess(res.data.shifts));
    dispatch(createResourceSuccess(res.data));
    toast.success(isLabor ? "Team created!" : "Resource created!");
    return res.data;
  } catch (err) {
    // err.response is absent whenever no response came back at all (network
    // failure, aborted request). Reading err.response.data unguarded threw
    // right here, inside the catch: the dispatch below never ran and the
    // toast after it was never reached, so a failed creation surfaced
    // nothing — no message in the form, none in the toaster.
    const data = err?.response?.data;
    dispatch(createResourceError(inlineRefusalOf(i18next.t, err) || data || {}));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(resourceErrorText(err, "Something went wrong"));
    return null;
  }
};

export const assignManagerToTeam = (teamId, managersId) => async (dispatch) => {
  dispatch(createManagerRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/resource/assign-team/${teamId}/manager`,
      managersId
    );
    dispatch(createManagerSuccess(res.data));
    toast.success("Team manager(s) assigned!");
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(createManagerError(err?.response?.data ?? {}));
    toast.error(resourceErrorText(err, "Something went wrong"));
  }
};

export const assignCollabsToTeam = (
  teamId,
  collabsId,
  isLabor = true
) => async (dispatch) => {
  dispatch(createCollabsRequest());
  try {
    await axios.post(`${PDA_PREFIX}/resource/assign-team/${teamId}`, collabsId);
    dispatch(createCollabsSuccess({ teamId, collabsId, isLabor }));
    toast.success(
      isLabor ? "Collab(s) assigned to team!" : "Resource(s) assigned to team!"
    );
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(createCollabsError(err?.response?.data ?? {}));
    toast.error(resourceErrorText(err, "Something went wrong"));
  }
};

export const updateResource = (resource, isTracked) => async (dispatch) => {
  //dispatch(updateResourceRequest());
  isTracked && dispatch(addItemPending(resource.id));
  try {
    const res = await axios.put(`${PDA_PREFIX}/resource/update`, resource);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
    dispatch(updateResourceSuccess(res.data));
    isTracked && dispatch(removeItemPending(resource.id));
    toast.success("Resource Updated!");
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateResourceError());
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
    toast.error("Something went wrong");
    isTracked && dispatch(removeItemPending(resource.id));
  }
};

export const deleteResource = (id, isTracked) => async (dispatch) => {
  dispatch(deleteResourceRequest());
  isTracked && dispatch(addItemPending(id));
  try {
    const res = await axios.delete(`${PDA_PREFIX}/resource/${id}`);
    dispatch(deleteResourceSuccess(res.data));
    isTracked && dispatch(removeItemPending(id));
    toast.success("Resource has been deleted");
  } catch (err) {
    dispatch(deleteResourceError(err));
    isTracked && dispatch(removeItemPending(id));
    toast.error(
      "Resource not deleted because assigned to at least one activity"
    );
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const getMappedResources = () => async (dispatch) => {
  dispatch(getMappedResourcesRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource/mapped-resources`);
    dispatch(getMappedResourcesSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getMappedResourcesError(err));
  }
};

export const getMappedResourcesManagedByUser = () => async (dispatch) => {
  dispatch(getMappedResourcesRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource/mapped-resources/all`);
    dispatch(getMappedResourcesSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getMappedResourcesError(err));
  }
};

export const getResourcesByScenarioId = (scenarioId) => async (dispatch) => {
  dispatch(getResourcesByScenarioIdRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource/resources/${scenarioId}`
    );
    dispatch(getResourcesByScenarioIdSuccess(res?.data || []));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourcesByScenarioIdError(err));
  }
};

// Portfolio-scope counterpart of getResourcesByScenarioId: a PortfolioScenario.id
// isn't a Scenario.id (see docs/resource-workload-capacity.md on the backend),
// so it can't be passed to /resource/resources/{scenarioId}. LABOR resource
// capacity metadata isn't scenario-scoped anyway (it's account/portfolio-wide),
// so /resource/all is the correct, already-existing source here.
export const getResourcesForPortfolioScenario = () => async (dispatch) => {
  dispatch(getResourcesByScenarioIdRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource/all`);
    dispatch(getResourcesByScenarioIdSuccess(res?.data || []));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getResourcesByScenarioIdError(err));
  }
};

export const getCollabsList = () => async (dispatch) => {
  dispatch(getCollabsRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource/collab-assigned/all`);
    dispatch(getCollabsSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getCollabsError(err));
  }
};

export const getSpecificNonLaborResources = () => async (dispatch) => {
  dispatch(getSpecificNonLaborResourcesRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource/specifics/all`);
    dispatch(getSpecificNonLaborResourcesSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getSpecificNonLaborResourcesError(err));
  }
};

export const getPortfolioCollabsAndSpecificResources = () => async (
  dispatch
) => {
  dispatch(getPortfolioCollabsAndSpecificResourcesRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource/specifics-and-collabs/all`
    );
    dispatch(getPortfolioCollabsAndSpecificResourcesSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getPortfolioCollabsAndSpecificResourcesError(err));
  }
};

export const getCollabsAndSpecificResourcesOfUser = () => async (dispatch) => {
  dispatch(getCollabsAndSpecificResourcesOfUserRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource/specifics-of-user`);
    dispatch(getCollabsAndSpecificResourcesOfUserSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getCollabsAndSpecificResourcesOfUserError(err));
  }
};

export const getTeams = () => async (dispatch) => {
  dispatch(getTeamsRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/resource/teams/all`);
    dispatch(getTeamsSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getTeamsError(err));
  }
};

export const getScenarioUsage = (scenarioId) => async (dispatch) => {
  dispatch(getPortfolioUsageRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource/scenario-usage/${scenarioId}`
    );
    dispatch(getPortfolioUsageSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getPortfolioUsageError(err.message));
  }
};

export const getScenarioUsageWithoutCapacity = (scenarioId) => async (
  dispatch
) => {
  dispatch(getScenarioUsageRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource/scenario-usage-without-capacity/${scenarioId}`
    );
    dispatch(getScenarioUsageSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getScenarioUsageError(err.message));
  }
};

// Portfolio-scenario counterpart of getScenarioUsageWithoutCapacity: merges
// LABOR/general usage across every project-scenario the portfolio scenario
// points to (see docs/resource-workload-capacity.md on the backend for why
// a PortfolioScenario.id can't be passed to the scenario-scoped route above).
// One in-flight usage load: a scenario switch aborts the previous one, so an old
// scenario's rows never land on the new one.
let usageWithoutCapacityController = null;

export const getPortfolioScenarioUsageWithoutCapacity = (portfolioScenarioId) => async (
  dispatch
) => {
  usageWithoutCapacityController?.abort();
  usageWithoutCapacityController = new AbortController();
  const { signal } = usageWithoutCapacityController;
  dispatch(startChunkLoad("usage"));
  dispatch(getScenarioUsageRequest());
  try {
    // Chunked by contract: the per-day rows are the heaviest Scenario Workspace payload,
    // and the widgets sum them per resource and month, so contract chunks simply add up.
    await loadInChunks({
      // No id: the portfolio's active projects (their current scenarios).
      url: portfolioScenarioId
        ? `${PDA_PREFIX}/portfolio-scenario/${portfolioScenarioId}/usages/scenario-usage-without-capacity`
        : `${PDA_PREFIX}/portfolio-scenario/usages/scenario-usage-without-capacity/active`,
      chunkSize: CONTRACTS_PER_CHUNK,
      signal,
      onProgress: ({ rows, ...progress }) => {
        dispatch(getScenarioUsageSuccess(rows));
        dispatch(chunkLoadProgress("usage", progress));
      },
    });
  } catch (err) {
    if (signal.aborted || axios.isCancel(err)) return;
    dispatch(chunkLoadProgress("usage", { complete: true }));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getScenarioUsageError(err.message));
  }
};

// Feed of the Roadmap's Resource-mode overload overlay: the same usage as the
// two endpoints above, summed per resource and month by the backend (see
// docs/roadmap-resource-overlay.md there). Resolves to the rows instead of
// storing them: the shared `scenarioUsage` slice keeps the per-day rows the
// Resource Planning widgets read, and the overlay keeps its own copy.
// Scope "active" (no id): the active projects of the user's portfolio.
export const getRoadmapResourceUsage = (scope, scenarioId) => async (dispatch) => {
  const url = scope === "active"
    ? `${PDA_PREFIX}/portfolio-scenario/usages/roadmap-resource-usage/active`
    : scope === "portfolio"
      ? `${PDA_PREFIX}/portfolio-scenario/${scenarioId}/usages/roadmap-resource-usage`
      : `${PDA_PREFIX}/resource/roadmap-resource-usage/${scenarioId}`;
  try {
    const res = await axios.get(url);
    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    return [];
  }
};

export const getCumulatedScenarioUsage = (scenarioId) => async (dispatch) => {
  dispatch(getScenarioUsageRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource/cumul-of-usages/${scenarioId}`
    );
    dispatch(getScenarioUsageSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getScenarioUsageError(err.message));
  }
};

export const clearResources = () => async (dispatch) => {
  dispatch({
    type: CLEAR_RESOURCES,
  });
};

export const clearResourcesErrorMessage = () => async (dispatch) => {
  dispatch({
    type: CLEAR_BACKEND_ERROR_MESSAGE,
    payload: {},
  });
};

export const deleteManagerFromTeam = (teamId, managerId) => async (
  dispatch
) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/resource/revoke-team/${teamId}/manager/${managerId}`
    );
    dispatch({
      type: DELETE_MANAGER,
      payload: managerId,
    });
    toast.success("The team manager has been deleted!");
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const deleteCollabFromTeam = (
  teamId,
  collabId,
  isLabor = true
) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/resource/revoke-team/${teamId}/${collabId}`
    );
    dispatch({
      type: DELETE_COLLAB,
      payload: collabId,
      teamId,
    });
    toast.success(
      isLabor
        ? "The collaborator has been removed from the team!"
        : "The resource has been removed from the team!"
    );
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(err.response?.data);
  }
};

export const resetPortfolioCapacity = () => async (dispatch) => {
  try {
    const res = await axios.put(
      `${PDA_PREFIX}/usages/all/reset-weekly-capacity`
    );
    dispatch({ type: RESET_WEEKLY_CAPACITY });
    toast.success("The portfolio capacity has been reseted!");
    return;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(err.response.data);
    return;
  }
};

export const erasePortfolioCapacity = () => async (dispatch) => {
  try {
    const res = await axios.post(`${PDA_PREFIX}/usages/all/erase-capacities`);
    dispatch({ type: ERASE_CAPACITY });
    toast.success("The portfolio capacity has been erased!");
    return;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(err.response.data);
    return;
  }
};

export const generateTeamsWorkload = () => async (dispatch) => {
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/project-buckets/generate/teams-workload`
    );
    dispatch({ type: GENERATE_TEAMS_WORKLOAD });
    toast.success("Resource(s) workload has been generated successfully!");
    return;
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(err.response.data);
    return;
  }
};

export const getDimensionResourcesByScenarioId = (scenarioId) => async (
  dispatch
) => {
  dispatch(getDimensionResourcesRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource/${scenarioId}/dimension-resources`
    );
    dispatch(getDimensionResourcesSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getDimensionResourcesError(err.message));
  }
};

export const getMyTeams = () => async (dispatch) => {
  dispatch(getMyTeamsRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/resource/my/teams/collaborators`
    );
    dispatch(getMyTeamsSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getMyTeamsError(err.message));
  }
};

export const createShift = (shift) => async (dispatch) => {
  dispatch(createShiftRequest());
  try {
    const res = await axios.post(`${PDA_PREFIX}/shift/create`, shift);
    dispatch(createShiftSuccess(res.data));
    toast.success("Shift was successfully created!");
  } catch (err) {
    dispatch(createShiftError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error("Something went wrong. Please contact support");
  }
};

export const fetchAllShifts = () => async (dispatch) => {
  dispatch(fetchShiftsRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/shift`);
    dispatch(fetchAllShiftsSuccess(res.data));
  } catch (err) {
    // todo customize error handling
    dispatch(fetchAllShiftsError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const deleteShift = (shiftId) => async (dispatch) => {
  dispatch(addItemPending(shiftId));
  dispatch(updateShiftsRequest());
  try {
    await axios.delete(`${PDA_PREFIX}/shift/${shiftId}`);
    dispatch(deleteShiftSuccess(shiftId));
    toast.success("Shift deleted successfully !");
    dispatch(removeItemPending(shiftId));
  } catch (err) {
    dispatch(deleteShiftError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const updateShifts = (shift) => async (dispatch) => {
  dispatch(addItemPending(shift.id));
  dispatch(updateShiftsRequest());
  try {
    const res = await axios.put(`${PDA_PREFIX}/shift/update`, shift);
    dispatch(updateShiftsSuccess(res.data));
    toast.success("Shift successfully updated !");
    dispatch(removeItemPending(shift.id));
  } catch (err) {
    dispatch(updateShiftsError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const fetchAllBudgetEnvelopes = () => async (dispatch) => {
  dispatch(fetchAllBudgetEnvelopesRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/budget-envelopes`);
    dispatch(fetchAllBudgetEnvelopesSuccess(res.data));
  } catch (err) {
    // todo customize error handling
    dispatch(fetchAllBudgetEnvelopesError(err));
    toast.error("Something went wrong. Please contact support");
  }
};

export const updateBudgetEnvelope = (budgetEnvelope) => async (dispatch) => {
  dispatch(updateBudgetEnvelopeRequest());
  try {
    const res = await axios.put(
      `${PDA_PREFIX}/budget-envelopes/${budgetEnvelope.id}`,
      budgetEnvelope
    );
    dispatch(updateBudgetEnvelopeSuccess(res.data));
    toast.success(`Budget of ${budgetEnvelope.year} successfully updated!`);
  } catch (err) {
    dispatch(updateBudgetEnvelopeError(err));
    toast.error("Something went wrong. Please contact support.");
  }
};
export const mutateShiftsWithoutRerender = (shiftId, field, value) => ({
  type: MUTATE_SHIFTS_WITHOUT_RERENDER,
  paylaod: { shiftId, field, value },
});

export const getResourceAuthorizationsAndCapabilities = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PDA_PREFIX}/authorization-and-capability`);
    dispatch({ type: GET_AUTHORIZATIONS_AND_CAPABILITIES, payload: res.data });
  } catch (err) {
    console.error("Something went wrong when fetching abilities", err);
  }
}

export const assignHabilitationsOnResource = (data, grid) => async (dispatch) => {
  // to show loader
  dispatch(getTeamsRequest());
  try {
    const res = await axios.post(`${PDA_PREFIX}/authorization-and-capability/assign`, data);
    dispatch({ type: UPDATE_AUTHORIZATIONS_AND_CAPABILITIES_ASSIGNED, payload: res.data });
    if (grid) {
      const resource = grid.store.getById(data.resourceId);
      if (resource) {
        if (resource.id in res.data.authorizationAssignedMap)
          resource.authorizationIds = res.data.authorizationAssignedMap[resource.id];
        if (resource.id in res.data.capabilityAssignedMap)
          resource.capabilityIds = res.data.capabilityAssignedMap[resource.id];
        toast.success(<div>Assignments of authorizations and skills done on <b>{resource.name}</b></div>)
      }
    }
  } catch (err) {
    dispatch(getTeamsError(err));
    toast.error("Something went wrong. Please contact support");
  }
}